import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib/store';
import {
  cancelGetBoardingCertificateResultRequest,
  failGetBoardingCertificateResult,
  setGetBoardingCertificateResult,
  setGetBoardingCertificateResultFromApi,
  updateGetBoardingCertificateResult,
  updateGetBoardingCertificateResultFromApi,
} from './get-boarding-certificate-result.actions';

/**
 * Service to handle async GetBoardingCertificateResult actions
 */
@Injectable()
export class GetBoardingCertificateResultEffect {
  /**
   * Set the state with the reply content, dispatch failGetBoardingCertificateResult if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setGetBoardingCertificateResultFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setGetBoardingCertificateResult({ model: reply, requestId: action.requestId }),
        (error, action) => of(failGetBoardingCertificateResult({ error, requestId: action.requestId })),
        cancelGetBoardingCertificateResultRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failGetBoardingCertificateResult if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateGetBoardingCertificateResultFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateGetBoardingCertificateResult({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failGetBoardingCertificateResult({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
